"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HostAvatar = void 0;
const react_1 = __importStar(require("react"));
const __1 = require("../../..");
const theme_1 = require("../../../services/theme");
const store_1 = require("../../../store");
const FadeInImage_1 = require("../../Input/components/FadeInImage");
const HostAvatar = () => {
    const chatbot = (0, store_1.useStoreState)((state) => state.chatbot.value);
    const hostAvatarUrl = (0, react_1.useMemo)(() => (chatbot ? (0, theme_1.parseTheme)(chatbot).hostAvatarUrl : undefined), [chatbot]);
    if (!chatbot)
        return react_1.default.createElement(react_1.default.Fragment, null);
    return (react_1.default.createElement("div", { className: "w-full h-full rounded-full text-2xl md:text-4xl text-center xs:w-10 xs:h-10" }, hostAvatarUrl ? (react_1.default.createElement(FadeInImage_1.FadeInImage, { className: "rounded-full w-full h-full object-cover", src: (0, __1.parseVariables)(hostAvatarUrl, chatbot.variables) })) : (react_1.default.createElement(__1.DefaultAvatar, { displayName: chatbot.name, size: "full" }))));
};
exports.HostAvatar = HostAvatar;
//# sourceMappingURL=HostAvatar.js.map